import React from 'react';
import EditorBullet from '@wix/da-ds/pkg/Icons/24x24/EditorBullet';
import EditorIconButton from '../_partials/EditorIconButton';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';

const BulletList: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'bulletList'))
  ) {
    return null;
  }

  if (editor.isActive('orderedList')) {
    return (
      <EditorIconButton
        featureId="format:bulletList"
        icon={EditorBullet}
        onClick={() => {
          editor
            .chain()
            .focus()
            .toggleList('bulletList', 'listItem', true)
            .run();
        }}
        isActive={editor.isActive('bulletList')}
        tooltipText={t('button.bulletlist.tooltip')}
        aria-label={t('button.bulletlist.tooltip')}
      />
    );
  }

  return (
    <EditorIconButton
      featureId="format:bulletList"
      icon={EditorBullet}
      onClick={() => editor.chain().focus().toggleBulletList().run()}
      disabled={!editor.can().chain().focus().toggleBulletList().run()}
      isActive={editor.isActive('bulletList')}
      tooltipText={t('button.bulletlist.tooltip')}
      aria-label={t('button.bulletlist.tooltip')}
    />
  );
};
BulletList.displayName = 'Bold';

export default BulletList;
